const buildPayments = (_ref, obfuscatedCredit) => {
  let {
    financeDownPayment,
    financeDownPaymentPercentage,
    selectedLoanTerm,
    selectedLeaseMileage,
    selectedLeaseTerm,
    interestRate: selectedInterestRate
  } = _ref;
  return {
    ...(financeDownPayment >= 0 && {
      downPayment: financeDownPayment
    }),
    // '0' is a valid value for financeDownPayment and financeDownPaymentPercentage
    ...(financeDownPaymentPercentage >= 0 && {
      downPaymentPercent: financeDownPaymentPercentage
    }),
    ...(selectedLoanTerm && {
      loanTerm: selectedLoanTerm
    }),
    ...(selectedLeaseMileage && {
      leaseMileageRange: selectedLeaseMileage
    }),
    ...(selectedLeaseTerm && {
      leaseTerm: selectedLeaseTerm
    }),
    ...(selectedInterestRate && Object.keys(selectedInterestRate).length && {
      interestRate: selectedInterestRate
    }),
    ...(obfuscatedCredit && {
      creditType: obfuscatedCredit
    })
  };
};
export { buildPayments as default };
